import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { useFetchCustomerArtiFactDataListQuery } from "../../../utils/customer/customerSelect";
import useRequireAuth from "../../../utils/useRequireAuth";
import useCustomFormValidation from "../../../hooks/ErrorHandling/useCustomFormValidation";
import { ReactComponent as CloseModalImg } from "../../../assets/images/closeModalImg.svg";
import CustomDrawer from "../../UniversalComponents/CustomDrawer";
import { DELETE_FILE, DELETE_FOLDER, UPLOAD_FILE } from "../../../utils/constants";
import { pushAlert } from "../../../utils/alertSlice";
import { useFetchCustomerDocumentDataQuery } from "../../../utils/customer/customerTaskTable";
import DocumentCard from "./DocumentCard";
import { getFileExtension, removeFileExtension, truncateString } from "../../../utils/utilityFunctions/stringUtility";
import { ReactComponent as DownloadIcon } from "../../../assets/images/downloadIcon.svg";
import SearchBar from "../../UniversalComponents/SearchBar";

const validationRules = {
  doc_type: {
    required: true,
    errorMessage: "doc  Type is required.",
  },
  document: {
    required: true,
    errorMessage: "document is required.",
  },
};
const DocumentDrawer = ({ isOpen, onClose, isDocumentOpen }) => {
  const dispatch = useDispatch();

  const user = useRequireAuth();
  const companyLocalData = localStorage.getItem("company_data");
  const parsedCompanyData = JSON.parse(companyLocalData);
  const folderId = isDocumentOpen?.folderId;
  const customerId = isDocumentOpen?.customerId;

  const [fileName, setFileName] = useState("");
  const [sizeError, setSizeError] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [deleteData, setDeleteData] = useState({});
  const [documentList, setDocumentList] = useState([]);

  const { token } = useRequireAuth();
  const {
    data: ArtiFactDataList,
    error: ArtiFactDataListerror,
    isLoading: ArtiFactDataListloading,
  } = useFetchCustomerArtiFactDataListQuery({ token });

  const {
    data: fetchedDocumentData,
    refetch: refetchDocumentData,
    isLoading,
  } = useFetchCustomerDocumentDataQuery({
    customerId: customerId,
    userId: user.user_id,
    orgId: user.org_id,
    companyId: parsedCompanyData.company_id,
    token: user?.token,
    folderId: folderId,
    // template_id: isDocumentOpen?.template_id,
  });

  const [documentUpload, setDocumentUpload] = useState(null);

  const [formErrors, setFormErrors] = useState({
    doc_type: "",
    document: "",
  });
  const [formData, setFormData] = useState({
    doc_type: ArtiFactDataList?.[0]?.type,
    document: "",
  });

  const { errors, handleChange, isFormValid } = useCustomFormValidation(formData, validationRules);

  const handleFieldChange = (e) => {
    const { name, value, files } = e.target;
    handleChange(e);
    console.log("file e", e);

    if (files && files.length > 0) {
      setSizeError(false);
      const file = files[0];

      if (file.size < 10485760) {
        setFileName(file.name);
        setFormData((prevFormData) => ({ ...prevFormData, document: file }));
      } else {
        setSizeError(true);
        setFileName("");
        setFormData((prevFormData) => ({ ...prevFormData, document: "" }));
      }
    } else {
      setFormData((prevFormData) => ({ ...prevFormData, [name]: value }));
    }
  };

  const triggerFileUpload = () => {
    document.getElementById("hiddenFileInput").click();
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    const formValid = isFormValid();
    if (!formValid) {
      return;
    }

    if (formData.document.size < 10485760) {
      const fileData = {
        doc_type: event.target.doc_type.value,
        file: formData.document,
        customer_id: customerId,
        company_id: parsedCompanyData.company_id,
        // descriptions: event.target.descriptions.value,
      };

      handleSubmitAttachDocument(fileData);
      // onClose();
    } else {
      setSizeError(true);
    }
  };

  const handleSubmitAttachDocument = async (fileData) => {
    const formData = new FormData();

    for (var key in fileData) {
      formData.append(key, fileData[key]);
    }

    try {
      const response = await fetch(
        `${UPLOAD_FILE}?userId=${user.user_id}&row_id=${isDocumentOpen?.row_id}&template_id=${isDocumentOpen?.template_id}`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${user?.token}`,
          },
          body: formData,
        }
      );

      if (response?.success || response?.data?.success || response?.data?.status || response?.ok) {
        dispatch(pushAlert({ type: "success", message: response?.message, visible: true }));
        refetchDocumentData();
      } else {
        dispatch(pushAlert({ type: "danger", message: response?.message, visible: true }));
      }
    } catch (error) {
      dispatch(pushAlert({ type: "danger", message: "Something went wrong", visible: true }));
    }
  };

  const mockHighlightText = (text, searchText) => {
    if (!searchText) return text;
    const parts = text.split(new RegExp(`(${searchText})`, "gi"));
    return parts.map((part, index) =>
      part.toLowerCase() === searchText.toLowerCase() ? (
        <span key={index} style={{ backgroundColor: "yellow" }}>
          {part}
        </span>
      ) : (
        part
      )
    );
  };

  const handleDeleteFileFolder = async ({ id = null }) => {
    let url;
    // if (deleteData.type === "file") {
    url = DELETE_FILE.replace("<ID>", id);
    // } else {
    //   url = DELETE_FOLDER.replace("<ID>", deleteData.id);
    // }

    try {
      const jsonRes = await fetch(url, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${user?.token}`,
        },
      });

      const respone = await jsonRes.json();
      console.log("response", respone);
      if (respone?.success || respone?.data?.success || respone?.data?.status) {
        refetchDocumentData();
        dispatch(pushAlert({ message: respone.data.message, type: "success", visible: true }));
        // setDeleteData({});
      } else {
        dispatch(pushAlert({ message: respone.data.message, type: "danger", visible: true }));
        // setDeleteData({});
      }
    } catch (error) {
      dispatch(pushAlert({ message: "Something went wrong", type: "danger", visible: true }));
      // console.error("Error deleting file:", error);
      // setDeleteData({});
    }
  };

  useEffect(() => {
    const handleEsc = (event) => {
      if (event.key === "Escape") {
        onClose();
      }
    };

    document.addEventListener("keydown", handleEsc);

    // Clean up the event listener
    return () => {
      document.removeEventListener("keydown", handleEsc);
    };
  }, [onClose]);

  useEffect(() => {
    setDocumentList(fetchedDocumentData?.data?.data || []);
  }, [fetchedDocumentData]);

  return (
    <CustomDrawer open={isOpen} onClose={onClose}>
      <div className="flex flex-col gap-3 h-full">
        <div className="flex items-center justify-between border-b-[1px] border-gray-300 p-3">
          <h3 className="text-16 font-500 text-[#434852]">Document</h3>
          <button
            onClick={onClose}
            type="button"
            className="text-454545 bg-transparent hover:bg-F1F5F8 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center"
            data-modal-hide="assets-modal"
          >
            <CloseModalImg className="w-3 h-3" />
            <span className="sr-only">Close modal</span>
          </button>
        </div>
        <form onSubmit={handleSubmit} className="w-full flex flex-col gap-3 px-4">
          <div className="">
            <label htmlFor="Designation" className="block mb-2 text-434852 text-14 font-400">
              Doc Type <span className=" text-red-500"> *</span>
              {errors && <span className="text-red-700"> {errors.doc_type}</span>}
            </label>
            <select
              className={`form-select rounded bg-white border border-DFE2E5 focus:outline-hidden focus:ring-0 focus:border-1D5D9B  active:border active:border-DFE2E5 text-gray-900 text-xs block w-full px-2.5 py-1 h-8 leading-normal`}
              id={`doc_type`}
              name="doc_type"
              value={formData.doc_type}
              onChange={handleFieldChange}
            >
              {/* { console.log("ArtiFactDataList", ArtiFactDataList)} */}
              {ArtiFactDataList?.data &&
                ArtiFactDataList?.data?.map((CountryData) => (
                  <option key={CountryData.id} value={CountryData.type}>
                    {CountryData.type}
                  </option>
                ))}
            </select>
            {formErrors.doc_type && <span className="text-red-500 text-xs">Cannot be left blank.</span>}
          </div>

          {/* File Input */}
          <div className="">
            <div className="relative border border-[#EAE2E2] rounded-md h-40 flex flex-col items-center justify-center text-gray-500 text-sm">
              <input
                type="file"
                onChange={handleFieldChange}
                className="absolute w-full h-full opacity-0 cursor-pointer z-10"
              />
              <div className="z-0 text-center px-3">
                <p className="text-[#66666699]">Drop files here or click to select from the device</p>
                <div className="mt-2 inline-block px-4 py-1.5 border rounded-md bg-gray-100 text-Table  hover:bg-gray-200 transition">
                  Upload from this device <DownloadIcon className="inline ml-1 w-4 h-4" />
                </div>
                {fileName && (
                  <p className="mt-2 text-blue-600 text-sm">
                    {removeFileExtension(truncateString({ str: fileName, maxLength: 30 })) +
                      "." +
                      getFileExtension(fileName)}
                  </p>
                )}
              </div>
            </div>

            {formErrors.document && <span className="text-red-500 text-xs">Cannot be left blank.</span>}
            {sizeError && <span className="text-red-500 text-xs">File size should be less than 10MB.</span>}
          </div>

          <div className="flex justify-end">
            <button
              disabled={!fileName || sizeError}
              type="submit"
              className="w-28 text-white bg-[#1D4469] hover:bg-[#092239] save-btn font-semibold border border-[#123251] py-1 px-5 ms-3 rounded-[5px] disabled:cursor-not-allowed"
            >
              Upload
            </button>
          </div>
        </form>

        <div className="flex flex-col min-h-0 grow px-4">
          <p className="text-16 font-500 text-[#434852] pb-1">Uploaded Files</p>
          <SearchBar onChange={(event) => setSearchTerm(event?.target?.value)} />
          <div className="flex flex-col gap-3 min-h-0 grow overflow-auto">
            {documentList
              ?.filter((docInfo) => docInfo?.display_name?.toLowerCase()?.includes(searchTerm?.toLowerCase()))
              ?.map((documentInfo, index) => {
                return (
                  <DocumentCard
                    key={index}
                    info={documentInfo}
                    highlightText={mockHighlightText}
                    searchText={searchTerm}
                    handleOnDelete={handleDeleteFileFolder}
                  />
                );
              })}
          </div>
          {documentList?.length === 0 && (
            <div className="flex items-center justify-center h-full">
              <p className="text-16 font-500 text-[#434852]">No documents uploaded</p>
            </div>
          )}
        </div>
      </div>
    </CustomDrawer>
  );
};

export default DocumentDrawer;
